module.exports = __webpack_public_path__ + "img/634e20b.png";